import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressSpinner} from "primeng/progressspinner";

@Component({
  selector: 'app-loading',
  standalone: true,
  templateUrl: './loading.html',
  imports: [
    CommonModule,
    ProgressSpinner,
  ],
  styleUrl: './loading.css'
})
export class Loading {

  @Input() loading: boolean = false;
  @Input() width: string = '100px';
  @Input() height: string = '100px';
  @Input() align: 'start' | 'center' | 'end' = 'center';
}
